import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const NavbarV2 = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const $ = window.$;
    $('body').removeClass('home-3');
  }, []); // S'exécute une fois après le rendu initial

  const publicUrl = process.env.PUBLIC_URL + '/';
  const imgattr = 'logo';
  console.log('process.env, process.env');

  return (
    <div className="navbar-area">
      <div className="navbar-top">
        <div className="container">
          <div className="row">
            <div className="col-md-8 text-md-left text-center">
              <ul>
                <li>
                  <p>
                    <i className="fa fa-phone" /> (+216) 71 90 54 29
                  </p>
                </li>
                <li>
                  <p>
                    <i className="fa fa-envelope-o" /> contact@exifod.com
                  </p>
                </li>
                <li>
                  <a href={`${publicUrl}assets/img/Catalogue-2025-Web.pdf`}>
                    <p>
                      <i className="fa fa-download"></i> Télécharger le
                      catalogue
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul className="topbar-right text-md-right text-center">
                <li className="social-area">
                  <li>
                    <a href="https://www.facebook.com/exifod">
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/exifod/posts/?feedView=all">
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-area-2 navbar-area navbar-expand-lg go-top">
        <div className="container nav-container">
          <div className="responsive-mobile-menu">
            <button
              className={`menu toggle-btn d-block d-lg-none ${
                isOpen ? 'open' : ''
              }`}
              onClick={toggleMenu}
              aria-expanded={isOpen}
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <img src={`${publicUrl}assets/img/logo3.webp`} alt={imgattr} />
            </Link>
          </div>
          <div
            className={`collapse navbar-collapse ${isOpen ? 'sopen' : ''}`}
            id="edumint_main_menu"
          >
            <ul className="navbar-nav menu-open" style={{ margin: '7px' }}>
              <li className="menu-item-has-children">
                <Link to="/">Accueil</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/domaine-dexpertise">Domaines D&apos;expertise</Link>
                <ul className="sub-menu">
                  <ul>
                    <li>
                      <Link to="/sousdomaine-dexpertise/1">
                        Projets et programmes <li>de développement</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/2">
                        Mines – Oil & Gas
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/3">
                        Modélisation et analyse<li> des données</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/4">
                        Environnement–<li>Développement durable</li>
                        <li>et social</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/5">
                        Passation des marchés
                      </Link>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <Link to="/sousdomaine-dexpertise/6">
                        Finance et comptabilité
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/7">
                        Management<li> des ressources humaines</li>
                        <li>et des organisations</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/8">
                        Finances publiques
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/9">Santé publique</Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/10">
                        Agriculture,&<li>nutrition et sécurité </li>
                        <li>alimentaire</li>
                      </Link>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <Link to="/sousdomaine-dexpertise/11">
                        Wash (water, sanitation <li>and hygiène)</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/12">Education</Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/13">
                        Infrastructures <li>& Gestion urbaine</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/14">
                        Décentralisation<li>& Gouvernance locale</li>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sousdomaine-dexpertise/15">
                        Informatique – systèmes
                        <li>
                          {' '}
                          d’informations – <li>télécommunication</li>
                        </li>
                      </Link>
                    </li>
                  </ul>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="/formation">Nos Formations</Link>
              </li>
              {/* <li className="menu-item-has-children">
                <Link to="/FicheMetierComp">Fiche Métiers</Link>
                <ul className="sub-menu menu-metier">
                  <ul>
                    <li>
                      <Link to="#">
                       Titre Métier 1
                      </Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 2</Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 3</Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 4</Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 5</Link>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <Link to="#">Titre Métier 6</Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 7</Link>
                    </li>
                    <li>
                      <Link to="#">
                      Titre Métier 8
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                      Titre Métier 9
                      </Link>
                    </li>
                    <li>
                      <Link to="#">Titre Métier 10</Link>
                    </li>
                  </ul>
                  
                </ul>
              </li> */}
              {/* <li className="menu-item-has-children">
                <Link to="#">Certification</Link>
              </li> */}
              <li className="menu-item-has-children">
                <Link to="/Actualites">Actualités</Link>
              </li>
              {/* <li className="menu-item-has-children">
                <Link to="#">Consulting</Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavbarV2;
